import * as React from 'react';
import { Box, Paper,Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';



const ServiceExcellence = () => {
  const ServiceExcellence = {
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    animateOut: 'fadeOut',
    // loop: true,
    margin: 20,
    nav: true,
    dots: false,
    navElement: 'div',
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 3
      },
      1000: {
        items: 5
      }
    }
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className='serviceExcellence relative' pt='0'>
        <Box sx={{ flexGrow: 1 }} className='ph-80'>
          <Grid container spacing={3} padding={3} alignItems={'center'}>
            <Grid item xs={12} py='0'>
              <Paper sx={{ backgroundColor: "transparent", boxShadow: "none", textAlign: "center" }} className='sectionTitle'>
                <Typography variant="h6_df" >
                  Lorem Ipsum
                </Typography>
                <Typography variant="h2"  display="block" >
                  Service Excellence
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} className="aboutSlider">
              <OwlCarousel className='owl-theme' {...ServiceExcellence}>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/1.jpg`} alt="" />
                  </Paper>
                </div>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/2.jpg`} alt="" />
                  </Paper>
                </div>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/3.jpg`} alt="" />
                  </Paper>
                </div>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/4.jpg`} alt="" />
                  </Paper>
                </div>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/5.jpg`} alt="" />
                  </Paper>
                </div>
                <div class='item'>
                  <Paper component="a" href="/" className="popularToursSlider"
                    sx={{
                      boxShadow: "none",
                      backgroundColor: 'transparent',
                      border: '#d7d7d7 1px solid',
                      borderRadius:'10px',
                      overflow:'hidden',
                    }}
                  >
                    <img src={`${process.env.REACT_APP_URL}images/service-excellence/3.jpg`} alt="" />
                  </Paper>
                </div>
              </OwlCarousel>
            </Grid>
          </Grid>
        </Box>
      </Box> 
    </>
  )
}

export default ServiceExcellence
